<template>
    <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
            <v-card>
                <v-card-media :src="picture" height="300px">
                    <v-layout column class="media">
                        <v-card-title>
                            <v-btn
                                    icon
                                    dark
                                    @click="goBack()"
                            >
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    icon
                                    dark
                                    class="mr-3"
                                    @click="goProfile()"
                            >
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <v-menu bottom left>
                                <v-btn
                                        icon
                                        dark
                                        slot="activator"
                                >
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile
                                            @click="signOut()"
                                    >
                                        <v-list-tile-title>Sign out</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-card-title>
                        <v-spacer/>
                        <v-card-title class="white--text pl-5 pt-5">
                            <div class="display-1 pl-5 pt-5">{{ profile.name }}</div>
                        </v-card-title>
                    </v-layout>
                </v-card-media>
                <v-card-text class="pa-0">
                    <me-profile-connections/>
                    <me-datastore-connections/>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'me',
        data() {
            return {};
        },
        computed: {
            ...mapGetters('auth', [
                'profile',
            ]),
            size() {
                return `${window.innerWidth}px`;
            },
            picture() {
                if (this.profile) {
                    return this.profile.picture;
                }

                return undefined;
            },
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            goProfile() {
                this.$router.push({ path: '/me/profile' });
            },
            signOut() {
                this.$store.commit('auth/LOGOUT');
                this.$router.push({ path: '/login' });
            },
        },
        created() {
        },
    };
</script>

<style lang="stylus" scoped>
    .card__media
        background-color #37345a

    // this is a bit awkward, but we need >>> because
    // the background is dynamically injected HTML
    // which doesn't inherit the data attribute that makes scoped styles work
    .card >>> .card__media__background
        -webkit-filter opacity(20%)
        filter opacity(20%)
</style>



// WEBPACK FOOTER //
// Me.vue?05790fbc